import { Injectable } from '@angular/core'

declare global {
  interface Window { __env: any; }
}

@Injectable({ providedIn: 'root' })
export class RuntimeConfigService {
  get dentalDSOAppId(): string {
    return window.__env?.AUTH_DSO_DENTAL_APPID;
  }

  get dentalDSOPassword(): string {
    return window.__env?.AUTH_DSO_DENTAL_PWD;
  }

  get equipmentProviderDSOAppId(): string {
    return window.__env?.AUTH_DSO_EQUIPPROVIDER_APPID;
  }

  get equipmentProviderDSOPassword(): string {
    return window.__env?.AUTH_DSO_EQUIPPROVIDER_PWD;
  }

 get dentalLoanAppId(): string {
    return window.__env?.AUTH_LOANAPP_DENTAL_APPID;
  }

  get dentalLoanAppPassword(): string {
    return window.__env?.AUTH_LOANAPP_DENTAL_PWD;
  }

  get equipmentProviderLoanAppId(): string {
    return window.__env?.AUTH_LOANAPP_EQUIPPROVIDER_APPID;
  }

  get equipmentProviderLoanAppPassword(): string {
    return window.__env?.AUTH_LOANAPP_EQUIPPROVIDER_PWD;
  }

  get mapsAPIKey(): string {
    return window.__env?.MAPS_API_KEY;
  }

  get trustPilotPublicKey(): string {
    return window.__env?.TRUSTPILOT_PUBLIC_KEY;
  }

  get trustPilotSecretKey(): string {
    return window.__env?.TRUSTPILOT_SECRET_KEY;
  }

  get trustPilotId(): string {
    return window.__env?.ICW_TRUSTPILOT_ID;
  }

  get localStorageKey(): string {
    return window.__env?.LOCAL_STORAGE_SECRET_KEY;
  }
  
  get ninthwaveAppId(): string {
    return window.__env?.NINTHWAVE_APP_ID;
  }

   get transUnionPublicKey(): string {
    return window.__env?.TRANSUNION_PUBLIC_KEY;
  }
}


